import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AskGeoService } from 'src/app/shared/services/ask-geo.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-ask-geo-result',
    templateUrl: './ask-geo-result.component.html',
    styleUrls: ['./ask-geo-result.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AskGeoResultComponent {
  searchKeyWord: string = '';
  searchResult: any[] = [];
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>();
  errorMessage: string = '';
  generatedSummary: any;
  generatedQuery: any;
  showGeneratedSummary = false;

  constructor(public askGeoService: AskGeoService) {}

  ngOnInit(): void {
    this.searchKeyWord = localStorage.getItem('askGeoSearchKeyword') || '';
    this.search();
  }

  public onKeySearchPress(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === 'Tab') {
      this.search();
    }
  }

  public onKeySearchButtonPress(event: MouseEvent): void {
    this.search();
  }

  public search(): void {
    if (!this.searchKeyWord || this.searchKeyWord === '') return;

    this.askGeoService.getSearchResults(this.searchKeyWord).subscribe({
      next: (result: any) => {
        this.generatedSummary = result.summary || '';
        this.generatedQuery = result.query || '';
        if (result.error) {
          this.errorMessage = result.error;
          this.dataSource.data = [];
          this.displayedColumns = [];
        } else if (result.rowData && result.rowData.length > 1) {
          this.errorMessage = '';

          const rawColumns = result.rowData[0];
          const dataRows = result.rowData.slice(1);
          const uniqueColumns: string[] = [];
          const columnCount: { [key: string]: number } = {};

          rawColumns.forEach((col: string) => {
            if (columnCount[col]) {
              columnCount[col]++;
              uniqueColumns.push(`${col}_${columnCount[col]}`);
            } else {
              columnCount[col] = 1;
              uniqueColumns.push(col);
            }
          });

          this.displayedColumns = uniqueColumns;
          this.searchResult = dataRows.map((row: any[]) => {
            const rowObj: any = {};
            this.displayedColumns.forEach((col, index) => {
              rowObj[col] = row[index];
            });
            return rowObj;
          });
          
          this.dataSource.data = this.searchResult;
        } else if(result.rowData.length <= 0) {
          this.errorMessage = 'No records found.';
          this.dataSource.data = [];
          this.displayedColumns = [];
        }
        else {
          this.errorMessage = '';
          this.dataSource.data = [];
          this.displayedColumns = [];
        }
      },
      error: (err) => {
        console.error('Error:', err);
        this.errorMessage = 'An error occurred while fetching data.';
        this.dataSource.data = [];
        this.displayedColumns = [];
      }
    });
  }
}
